import type { TransactionCurrency } from '@contracts/payment/Currency';
import { BaseModal } from '@src/common/components/BaseModal';
import { useTranslation } from 'react-i18next';

import { MakePaymentForm } from './MakePaymentForm';

export const MakePaymentModal = ({
  isOpen,
  onClose,
  clientId,
  orderId,
  onPaymentSuccess,
  onPaymentError,
  blockedCurrency,
  maxBillable,
}: {
  orderId: string;
  clientId: string;
  isOpen: boolean;
  onClose: () => void;
  onPaymentSuccess: () => void;
  onPaymentError: () => void;
  blockedCurrency?: TransactionCurrency;
  maxBillable: number;
}) => {
  const { t } = useTranslation();

  const handlePaymentSuccess = () => {
    onPaymentSuccess();
    onClose();
  };

  const handlePaymentError = () => {
    onPaymentError();
    onClose();
  };

  return (
    <BaseModal
      open={isOpen}
      onClose={onClose}
      title={t('makePayment.title')}
      subtitle={t('makePayment.description')}
      marginBottom="0"
    >
      <MakePaymentForm
        clientId={clientId}
        orderId={orderId}
        onPaymentSuccess={handlePaymentSuccess}
        onPaymentError={handlePaymentError}
        onCancel={onClose}
        blockedCurrency={blockedCurrency}
        maxBillable={maxBillable}
      />
    </BaseModal>
  );
};
